// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// VisibilityMode — source: shared/config/visibility_mode.config.json

export const VISIBILITY_MODE_VALUES = ["everyone", "everyone_edit", "owner_and_shared", "team", "custom"] as const;
export type VisibilityMode = (typeof VISIBILITY_MODE_VALUES)[number];

